<template>
  <div>
    <header class="dashboard-header">
      <div class="container-cls">
        <v-row justify="center">
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="2"
            lg="2"
            xl="2"
            class="grow-logo"
          >
            <router-link :to="{ path: '/' }" class="dashboard-logo">
              <img
                src="https://growbiotech-prod.s3.amazonaws.com/1606973000233.png"
                alt
              />
            </router-link>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10" class="">
            <h2 class="page-header">
              <strong>Terms and Conditions</strong>
            </h2>
          </v-col>
        </v-row>
      </div>
    </header>
    <v-list :class="$vuetify.breakpoint.xsOnly ? 'pa-3 pt-0' : 'pa-15 pt-0'">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text">1. Welcome</v-list-item-title>
          <v-list-item-subtitle class="subtitle-text"
            >Welcome to Grow Pharma Doctor Portal (the "Site"), which is owned
            and operated by Grow Group Plc ("Grow Group Plc", "we", "us" or
            "our"). Please read these terms of use ("Terms") carefully. By
            accessing or using the Site, by using any interactive areas of the
            Site, or by uploading, submitting, browsing or downloading any
            video, audio, images, text, or other content ("Content") to or from
            the Site, you agree to be bound by these Terms and all policies and
            guidelines we issue. If you do not agree to all of these Terms, do
            not use the Site or any of the interactive areas and do not access
            any videos. The "Site" includes by definition, and these Terms apply
            to, the Site itself, and any mobile app, web pages, interactive
            features, other applications, widgets, blogs, social networks,
            social network "tabs," or other online or wireless offerings that
            link to these Terms, whether accessed via computer, mobile device or
            other technology, manner or means.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >These Terms apply exclusively to your access to, and use of, the
            Site, your use of the Interactive Areas, and your access and use of
            Content. However, these Terms do not alter in any way the terms or
            conditions of any other agreement you may have with us, or our
            subsidiaries or affiliates ("Affiliates"), for products, services or
            otherwise. Your use of the Site and the Interactive Areas and your
            access and use of Content is subject to, and expressly conditioned
            upon your agreement to, these Terms. If you are using the Site or
            the Interactive Areas or are accessing and using Content on behalf
            of any entity, you represent and warrant that you are authorised to
            accept these Terms of Use on such entity's behalf, and that such
            entity will be responsible for and indemnify us for violations of
            these Terms. If you violate the Terms, we may terminate your use of
            the Site, bar you from future use of the Site, and/or take
            appropriate legal action against you.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >If you have any question regarding the use of the Site, please
            refer first to the FAQ posted on the Site. For all other questions
            or comments about the Site or its contents, please email
            info@growgroupplc.com.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >2. Update to Terms</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We reserve the right to change or modify any of the terms of use
            contained in these Terms or any policy or guideline of the Site, at
            any time and in our sole discretion. Any such changes or
            modifications will be effective immediately upon posting of the
            revisions on the Site. Your continued use of the Site following the
            posting of such changes or modifications constitutes your acceptance
            thereof. Therefore, you should frequently review these Terms and all
            applicable policies or guidelines on the Site, to understand the
            terms of use applicable to your use of the Site or your access and
            use of Content. If you do not agree to any changes or modifications
            to these Terms or to any applicable policies or guidelines on the
            Site, your sole recourse is to stop using the Site, features on the
            Site, and the Interactive Areas, and do not access or use any
            Content.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >3. Privacy Policy</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Please refer to the Site's Privacy Policy for information on how we
            collect, use, and disclose information from users of the Site. Your
            use of the Site signifies your acknowledgment of, and agreement to,
            the Privacy Policy. If you are a resident of any country outside the
            United Kingdom, including, but not limited to, any country within
            the European Union, you understand and agree that we store and
            process your personal information on computers located in Ireland
            (EU) (with possible transit through US storage containers), and that
            by providing any information to us, you consent to the transfer of
            such information to the European Union and United
            States.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >4. Electronic Communications</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >When you visit the Site or send emails to us, you communicate with
            us electronically and consent to receive communications from us
            electronically. We may communicate with you by: (a) email to your
            email address indicated in your communications with us, (b) posting
            general notices on the Site, or (c) posting messages that are
            displayed to you when you log in to or access the Site. You agree
            that all agreements, notices, disclosures and other communications
            that we provide to you electronically satisfy any legal requirement
            that such communications be in writing.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >5. Access to Site</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Before you start using the Site or access any Interactive Areas or
            Content, you must complete the online registration process by
            providing accurate, current and complete information about you (the
            Registration Data) and accept these Terms. By completing the
            registration process, you represent that you are at least eighteen
            (18) years of age. Upon our acceptance of your registration form, in
            our sole discretion, we will provide you with log-in identification
            and a unique password to enable you to access your account. You will
            be solely responsible for the safe custody of your log-in
            identification and password and to avoid its misuse by any third
            party. We do not guarantee the continued availability of the Site or
            your account to you. We reserve the right to deny your registration
            request or to terminate or suspend your account at any time, with or
            without any reason. In consideration of your use of the Site, you
            agree to (a) maintain the security of your password and
            identification; (b) maintain and promptly update the Registration
            Data, and any other information you provide to us, to keep it
            accurate, current and complete; and (c) accept all risks of
            unauthorized access to the Registration Data and any other
            information you provide to us.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >6. Copyright and Limited License</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Unless otherwise indicated in the Site, the Site and all content
            and other materials on the Site, including, but not limited to, our
            logo and all designs, text, graphics, logos, icons, images,
            photographs, audio clips, Content, digital downloads, data
            compilations, software and the selection and arrangement thereof
            (collectively, the "Materials") are our property or that of our
            Affiliates, licensors or users and are protected by United Kingdom
            and/or international copyright. You may not remove any notices or
            credits posted on the Site, or any additional information contained
            along with any such notices and credits.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We grant you a limited, non-sub-licensable and non-exclusive
            license to access and make use of the Site and electronically copy
            (except where prohibited without a license) and print to hard copy
            portions of the Site for your informational, non-commercial and
            personal use only, solely in accordance with, and subject to, these
            Terms and any other agreement you may enter into with us or any of
            our Affiliates. Such license does not include, except as and to the
            extent otherwise expressly permitted by these Terms: (a) the
            collection, use, copying or distribution of any portion of the Site
            or the Materials; (b) any resale, commercial use, commercial
            exploitation, distribution, public performance or public display of
            the Site or any of the Materials; (c) modifying or otherwise making
            any derivative uses of the Site or the Materials, or any portion
            thereof; (d) use of data mining, robots or similar data gathering or
            extraction methods; (e) downloading (other than page caching) of any
            portion of the Site, the Materials or any information contained
            therein, except as expressly permitted on the Site; or (f) any use
            of the Site or the Materials other than for their intended
            purposes.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Any use of the Site or of any Materials not owned by you, other
            than as specifically authorised herein, without our prior written
            consent, is strictly prohibited and will terminate this license
            grant and constitute a breach of this license grant. Such
            unauthorised use may also violate applicable laws, including, but
            not limited to, copyright and trademark laws and applicable
            communications regulations and statutes. Unless otherwise expressly
            stated, nothing in these Terms will be construed as conferring any
            license to intellectual property rights, whether by estoppel,
            implication or otherwise. In the event any license (which is not
            expressly granted under these Terms) is otherwise deemed to be
            granted to you by operation of law or otherwise, you hereby
            irrevocably assign to us forever all right, title and interest
            therein, without any fee. In addition, such license will be
            revocable by us at any time without any
            penalty.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Without our express consent, you agree that: (i) you will not use
            any robot, spider, other automatic device, or manual process to
            monitor or copy the Site, or any pages or content available on the
            Site, for any other purpose; (ii) you will not use any device,
            software or routine to interfere or attempt to interfere with the
            proper working of the Site; (iii) you will not take any action that
            imposes an unreasonable or disproportionately large load on our
            infrastructure; and (iv) you will not copy, reproduce, alter,
            modify, create derivative works, or publicly display any content
            (except for your own personal, non-commercial use) from the
            Site.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >7. Copyright Complaints</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >It is our policy to respond promptly to claims of intellectual
            property misuse. If you believe that your work has been copied and
            is accessible on the Site in a way that constitutes copyright
            infringement, please notify us through the process set forth below.
            If we determine, based on our sole discretion that you are a repeat
            offender under UK Copyright Law, all your content will be removed,
            and we reserve the right to take whatever other actions we deem
            necessary, including notifying the appropriate government
            authorities. We may at our sole discretion limit access to the Site
            and/or terminate the accounts of any users who infringe any of our
            intellectual property rights or those of others (including, but not
            limited to, our Affiliates), whether or not there is any repeat
            infringement.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >WRITTEN NOTICE OF ANY CLAIMED COPYRIGHT INFRINGEMENT MUST BE
            SUBMITTED TO THE DESIGNATED AGENT NAMED BELOW. ANY NOTICE SENT TO
            THE DESIGNATED AGENT MUST MEET THE REQUIREMENTS OF THE
            ACT.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Designated to Receive Notification of Claimed
            Infringement:</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Name: Donnie Bachan, CTO</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >E-mail: donnie.bachan@growgroupplc.com</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Note: any email notifications should include "notice of alleged
            service provider infringement" in the subject line of the
            email.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Such notice must include the following
            information:</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >1. The name, address, and electronic signature of the complaining
            party.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >2. A description of the infringing materials and a link to the
            infringing materials, or if a link is not available a description of
            the location of these materials on the
            website.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >3. Sufficient information to identify the copyrighted
            works.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >4. A statement by the copyright owner that the copyright owner has
            a good faith belief that there is no legal basis for the use of the
            materials complained of.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >5. A statement of the accuracy of the statements made and, under
            penalty of perjury, a statement that the complaining party is
            authorised to act on the behalf of the copyright
            owner.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Once proper notice is given, we will take the material down. A
            party whose material was removed improperly may send counter notice
            to the above-referenced address. Counter-notice must including the
            following:</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >1. The sender’s name, address, phone number and physical or
            electronic signature.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >2. Identification of the material and its location prior to
            removal.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >3. A statement under penalty of perjury that the material was
            removed by mistake or misidentification.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >4. The sender’s consent to local federal court jurisdiction, or if
            overseas, to an appropriate judicial body.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >8. Hyperlinks</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >You are granted a limited, non-sub-licensable and non-exclusive
            right to create a text hyperlink to the Site for non-commercial
            purposes; provided such link does not portray us or any of our
            products or services in a false, misleading, derogatory or otherwise
            defamatory manner; and provided, further, that the linking site does
            not contain any pornographic, illegal material or material that is
            offensive, harassing or otherwise objectionable material. This
            limited right may be revoked by us at any time, with or without any
            reason. You may not use a Grow Group Plc logo or any other of our
            proprietary graphics to link to the Site without our prior written
            consent. Further, you may not use, frame or utilise framing
            techniques to enclose any Grow Group Plc trademark, service mark,
            logo or any other of our proprietary information, including, but not
            limited to, the images found at the Site, the content of any text or
            the layout/design of any page or form contained on a page on the
            Site without our prior written consent. Except as noted above, you
            are not conveyed any right or license by implication, estoppel or
            otherwise in or under any of our patent, trademark, copyright or
            proprietary rights or those of any third
            party.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >9. Third Party Sites</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We may host or provide links to products, Web pages, Websites and
            other content of third parties (Third Party Sites). The inclusion of
            any link or the hosting of any content is provided solely as a
            convenience to our users, including you, and does not imply
            affiliation, endorsement, approval, control or adoption by us of any
            Website or any information or content contained therein. We make no
            claims or representations regarding, and accept no responsibility
            for such Third Party Sites, or for the quality, accuracy, nature,
            ownership or reliability thereof. Users, including you, may use
            these links and the Third Party Sites contained therein at their own
            risk. When you leave the Site, you should be aware that our terms
            and policies no longer govern. You should review the applicable
            terms and policies, including privacy and data gathering practices,
            of any Website to which you navigate from the
            Site.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >10. Advertisements and Promotions; Third Party Products and
            Services</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We may run advertisements and promotions from third parties on the
            Site or may otherwise provide information or links to third party
            products or services on the Site. Your business dealings or
            correspondence with, or participation in promotions of our
            advertisers and any terms, conditions, warranties or representations
            associated with such dealings or promotions, are solely between you
            and such third party. We are not responsible or liable for any loss
            or damage of any sort incurred as a result of any such dealings or
            promotions or as the result of the presence of such third party
            advertisers or third party information on the
            Site.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >11. User content or Interactive Areas</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >The Site includes (or may include in future) content hosting and
            storage services, discussion forums, user-generated content or other
            interactive areas or services (collectively, Interactive Areas),
            including, but not limited to, galleries, forums, chat rooms, blogs
            (including, but not limited to, The Grow Group Plc Blog), message
            boards, online hosting or storage services, or other areas or
            services in which you or third parties create, post or store
            content, messages, materials, data, information, text, music, sound,
            photos, video, graphics, code or other items or materials on the
            Site (collectively, User Content). You are solely responsible for
            your use of and access to the Interactive Areas and you will use the
            Interactive Areas at your own risk.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >By using any Interactive Areas, you agree not to post, upload to,
            transmit, distribute, store, create or otherwise publish through the
            Site any of the following:</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >1. Any User Content that is unlawful, libellous, defamatory,
            obscene, pornographic, indecent, lewd, suggestive, harassing,
            threatening, invasive of privacy or publicity rights, abusive,
            inflammatory, fraudulent or otherwise objectionable or harmful,
            including, but not limited to, any User Content containing nudity
            that would be unacceptable to display publicly (in our sole
            opinion);</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >2. User Content that would constitute, encourage or provide
            instructions for a criminal offense, violate the rights of us or
            others (including, but not limited to, our Affiliates), endanger
            national security, or that would otherwise create liability or
            violate any local, state, national or international
            law;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >3. User Content that may infringe or violate any patent, trademark,
            trade secret, copyright or other intellectual or other proprietary
            right of us or others (including, but not limited to, our
            Affiliates). By posting any User Content, you represent and warrant
            that you have the lawful right to use, display, distribute, and
            reproduce such User Content;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >4. User Content that impersonates any person or entity or otherwise
            misrepresents your affiliation with a person or
            entity;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >5. Unsolicited promotions, political campaigning, advertising or
            solicitations;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >6. Private information of us or others (including, but not limited
            to, our Affiliates), including, but not limited to, addresses, phone
            numbers, email addresses, Social Security numbers and credit card
            numbers;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >7. Viruses, corrupted data or other harmful, disruptive or
            destructive files; and</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >8. User Content that, in our sole judgment, is objectionable,
            harmful or which restricts or inhibits any other person from using
            or enjoying the Interactive Areas or the Site, or which may expose
            us or our users to any harm or liability of any nature or
            type.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Although we prohibit certain activities in these Terms, we do not
            control and take no responsibility or liability for any User Content
            posted, stored or uploaded by you or any third party, or for any
            loss or damage thereto, nor are we liable for any mistakes,
            defamation, slander, libel, omissions, falsehoods, obscenity,
            pornography or profanity you may encounter by use of the Site,
            including the Interactive Areas. Your use of the Site and the
            Interactive Areas is at your own risk. As a provider of interactive
            services, we are not liable for any statements, representations or
            User Content provided by our users in any public gallery, forum,
            personal home page or other Interactive Area. We have no obligation
            to screen, edit or monitor any User Content posted in any
            Interactive Areas.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Judgments as to the acceptability of User Content are at our sole
            discretion, and we reserve the right, and have absolute discretion,
            to remove, screen or edit the Content posted or stored on the Site
            at any time and for any reason without notice. You are solely
            responsible for creating backup copies of and replacing any User
            Content you post or store on the Site at your sole cost and expense.
            Any use of the Interactive Areas or other portions of the Site in
            violation of the foregoing violates these Terms and may result in,
            among other things, termination or suspension of your rights to use
            the Interactive Areas and/or the Site.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >You understand and acknowledge that any User Content contained in
            public postings, including, but not limited to, any portions of the
            Site that may be designated as private, will be accessible to the
            public and could be accessed, indexed, archived, linked to and
            republished by others, including, but not limited to, appearing on
            other Websites and in search engine results. Therefore, you should
            be careful about the nature of the Content you post. We will not be
            responsible or liable for any third party access to or use of the
            User Content you post. You represent and warrant that: (a) you own
            or otherwise control all of the rights to the User Content that you
            post, or you otherwise have the right to post such User Content to
            the Site and to grant the rights granted herein; (b) the User
            Content you supply is accurate and not misleading; and (c) use and
            posting of the User Content you supply does not violate these Terms
            and will not violate any rights of or cause injury to any person or
            entity.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >If you post User Content to the Site, unless we indicate otherwise,
            you grant us and our Affiliates a non-exclusive, royalty-free,
            perpetual, irrevocable and fully sublicensable right to use,
            reproduce, modify, adapt, publish, translate, create derivative
            works from, distribute, perform and display such User Content
            throughout the world in any media on or in connection with the Site.
            You grant us and our Affiliates and sublicensees the right to use
            the name that you submit in connection with such content, if they
            choose.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >In order to cooperate with legitimate governmental requests,
            subpoenas or court orders, to protect our systems and customers, or
            to ensure the integrity and operation of our business and systems,
            we may access and disclose any information we consider necessary or
            appropriate, including, without limitation, user profile information
            (i.e. name, email address, etc.), IP addresses and traffic
            information, usage history, and posted User Content. our right to
            disclose any such information shall govern over any terms of the
            Privacy Policy.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >12. Your Submissions</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >By posting any content on the Site, you represent, warrant, and
            promise to us that you have provided notice as required under
            applicable law and obtained all consents, releases and licenses from
            any and all persons and entities that appear in any content you
            post, or that have any interest in any content you post. We shall
            not be responsible for obtaining any permissions, releases,
            licenses, or consents for any content you post to the
            Site.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >By posting any content on the Site, you grant us a perpetual,
            non-exclusive, royalty-free right to use, publish, distribute,
            reproduce, perform, adapt and display such content on the Site,
            including, but not limited to, the right to use the name that is
            submitted in connection with such content. You further understand
            and agree that, in order to help ensure smooth operation of the
            Site, we may keep backup copies of such content
            indefinitely.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Notwithstanding the foregoing, you acknowledge and agree that any
            materials, including, but not limited to, questions, comments,
            suggestions, feedback, ideas, plans, creative materials or other
            information or work of authorship, provided by you in the form of
            email or other submissions to us or otherwise posted on the Site
            will become our sole property. We will own worldwide and exclusive
            rights, including, but not limited to, all intellectual property
            rights embodied therein, and will be entitled to the unrestricted
            use and dissemination of such submissions for any purpose,
            commercial or otherwise, without acknowledgment or compensation or
            reimbursement of any kind to You. By making such submissions, you
            acknowledge and agree that: (a) your submissions do not contain
            confidential or proprietary information; (b) we are not under any
            obligation of confidentiality, express or implied, with respect to
            the submissions; (c) we will be entitled to use or disclose (or
            choose not to use or disclose) any submissions for any purpose, in
            any way, in any media worldwide; (d) we may have something similar
            to the submissions already under consideration or in development;
            (e) your submissions automatically become our property without our
            obligation to you; and (f) we may, but are not obligated to, review
            or monitor areas on the Site where users may transmit or post
            communications.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >13. Disclaimer of Warranties</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >THE SITE, THE MATERIALS, THE CONTENT, AND OTHER INFORMATION
            AVAILABLE ON THE SITE (INCLUDING, BUT NOT LIMITED TO, IN THE GROW
            GROUP PLC BLOG) ARE PROVIDED TO YOU ON AN "AS IS" OR "AS AVAILABLE"
            BASIS WITHOUT ANY REPRESENTATIONS, WARRANTIES OR CONDITIONS OF ANY
            KIND - WHETHER EXPRESS, IMPLIED OR STATUTORY AND WHETHER ARISING OUT
            OF A COURSE OF DEALING, COURSE OF PERFORMANCE OR USAGE OR TRADE. WE
            EXPRESSLY DISCLAIM, WITHOUT LIMITATION, ANY WARRANTIES, EXPRESS OR
            IMPLIED INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OR
            CONDITIONS OF NON-INFRINGEMENT, MERCHANTABILITY, MERCHANTABLE
            QUALITY, AND FITNESS FOR A PARTICULAR PURPOSE OR
            USE.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >WE DO NOT REPRESENT OR WARRANT THAT THE MATERIALS, THE CONTENT AND
            OTHER INFORMATION AVAILABLE ON THE SITE (INCLUDING, BUT NOT LIMITED
            TO, IN THE GROW GROUP PLC BLOG) ARE ACCURATE, COMPLETE, RELIABLE,
            CURRENT, FREE OF DEFECT, STABLE OR ERROR-FREE OR THAT THE SITE, ITS
            WEB SERVERS OR ANY EMAIL SENT BY US OR FROM THE SITE ARE FREE OF
            VIRUSES OR OTHER HARMFUL COMPONENTS.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >WE ARE NOT RESPONSIBLE FOR TYPOGRAPHICAL ERRORS OR OMISSIONS
            RELATING TO PRICING, TEXT OR PHOTOGRAPHY.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >WE ALSO MAKE NO REPRESENTATIONS, WARRANTIES OR CONDITIONS - WHETHER
            EXPRESS, IMPLIED OR STATUTORY AND WHETHER ARISING OUT OF A COURSE OF
            DEALING, COURSE OF PERFORMANCE OR USE - REGARDING THE AVAILABILITY,
            RELIABILITY OR SECURITY OF THE SITE AND WILL NOT BE LIABLE FOR ANY
            UNAUTHORISED ACCESS TO OR ANY MODIFICATION, SUSPENSION,
            UNAVAILABILITY, OR DISCONTINUANCE OF THE SITE, THE MATERIALS, THE
            CONTENT AND OTHER INFORMATION AVAILABLE ON THE SITE (INCLUDING, BUT
            NOT LIMITED TO, IN THE GROW GROUP PLC BLOG).</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >14. Limitation of Liability</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >REGARDLESS OF WHETHER ANY REMEDY SET FORTH HEREIN FAILS OF ITS
            ESSENTIAL PURPOSE OR OTHERWISE, IN NO EVENT WILL WE, OUR AFFILIATES,
            LICENSORS, OR OUR OR THEIR RESPECTIVE DIRECTORS, MEMBERS, EMPLOYEES
            OR AGENTS, BE LIABLE TO YOU OR TO ANY THIRD PARTY FOR ANY LOST
            PROFITS, LOST REVENUE, LOST DATA, INTERRUPTION OF BUSINESS, OR OTHER
            INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE OR CONSEQUENTIAL
            DAMAGES OF ANY KIND ARISING OUT OF THESE TERMS OF USE, OR YOUR USE
            OR INABILITY TO USE THE SITE, THE MATERIALS, THE CONTENT OR OTHER
            INFORMATION CONTAINED IN OR ACCESSED THROUGH THE SITE, EVEN IF WE
            HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS OR DAMAGES AND
            WHETHER OR NOT SUCH LOSS OR DAMAGES ARE FORESEEABLE. OUR AFFILIATES
            AND LICENSORS WILL NOT BE LIABLE TO YOU FOR ANY DIRECT DAMAGES. OUR
            AGGREGATE LIABILITY UNDER THESE TERMS OF USE FOR ANY CLAIMS IS
            LIMITED TO THE NET AMOUNTS RECEIVED BY US FROM YOU, IF ANY, FOR
            ACCESS TO OR USE OF THE SITE, THE MATERIALS, AND/OR THE CONTENT AT
            ISSUE. THE EXISTENCE OF ONE OR MORE CLAIMS WILL NOT ENLARGE THIS
            LIMIT CERTAIN LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR
            THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY
            TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS, OR
            LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL
            RIGHTS.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >15. Disclaimer of Tort Liability</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >The foregoing warranties and remedies are EXCLUSIVE and you waive
            and release all other warranties, obligations, and liabilities of us
            and all other remedies, claims, and rights that you may have
            relating in any way to the Site, the Materials, and the Content,
            whether arising from contract, warranty, strict liability or tort or
            from our negligence, tort or other fault, including, but not limited
            to, claims for loss of or damage resulting from the use or access to
            any Content.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >16. Indemnification</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >You agree to indemnify, defend and hold us, our Affiliates, and our
            and their respective independent contractors, service providers,
            consultants, directors, officers, employees and agents, and
            applicable third parties (such as licensors, partners and
            advertisers) (collectively, the Indemnified Parties) harmless from
            and against any actual or threatened suit, demand or claims,
            damages, costs, liabilities, losses and expenses (including, but not
            limited to, penalties, fines, damage awards, settlement amounts, and
            reasonable attorneys' fees) brought against any Indemnified Parties,
            arising out of or relating to (a) your use of the Site, the
            Materials, or the Content (including, but not limited to, your use,
            installation or service of the Materials, or the Content); (b) your
            conduct; (c) your failure to perform your obligations under these
            Terms (including, but not limited to, your violation of these
            Terms); (d) any violation of applicable law, rules or regulations by
            you or your personnel; and/or (e) your violation of the rights of
            any third party.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >17. Termination</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Notwithstanding any of these Terms, we reserve the right, without
            notice and in our sole discretion, to terminate your license to use
            the Site, and to block or prevent your future access to and use of
            the Site.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >18. Miscellaneous</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Your use of the Site is subject to all applicable local, state,
            national and international laws and regulations. You hereby
            irrevocably and unconditionally consent and submit to the exclusive
            jurisdiction of such courts over any suit, action or proceeding
            arising out of these Terms. The application of the Uniform Computer
            Information Transactions Act is expressly excluded. You will not
            assign any of your rights and obligations under these Terms without
            our prior written consent. Nothing in these Terms will restrict or
            limit any assignment by us of our rights or obligations herein to
            third parties, including, but not limited to, our Affiliates. If any
            provision of these Terms is found to be void or unenforceable, then
            the remainder will have full force and effect, and the invalid
            provision will be partially enforced to the maximum extent permitted
            by law to effectuate the purpose of these
            Terms.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >By using the Site you confirm:</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >I HAVE READ AND AGREE to all of the terms in the Website Terms of
            Use.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >I ACKNOWLEDGE AND AGREE that all Content submitted to the Site,
            including personal information, may be transferred outside the
            United Kingdom for processing by Grow Group Plc in accordance with
            the Site’s Privacy Policy.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >I ACKNOWLEDGE AND AGREE that it is my responsibility to ensure that
            my submission of any Content to the Site complies with applicable
            laws, including any applicable requirements to provide notice to, or
            obtain valid consent from, data subjects for the transfer of
            personal information about them outside the United Kingdom for
            processing by Grow Group Plc as described in the Site’s Privacy
            Policy.YOU MAY REVOKE YOUR CONSENT TO HAVE YOUR PERSONAL INFORMATION
            TRANSFERRED OUTSIDE THE UNITED KINGDOM OR PROCESSED WITHIN OUR
            SYSTEMS. TO DO SO, PLEASE CONTACT US VIA THE EMAIL ADDRESS NOTED AND
            INDICATE THAT YOU CHOOSE TO REVOKE YOUR
            CONSENT.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <div class="bg-shape">
        <img
          src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606299668242.png"
          alt
        />
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
.title-text {
  font-size: 24px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 8px 0px;
  line-height: 1.4 !important;
  font-family: "Nunito Sans", sans-serif !important;
}
.subtitle-text {
  font-size: 18px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 12px 0px;
  line-height: 1.4 !important;
  font-family: "Nunito Sans", sans-serif !important;
}
.subtitle-inner-text {
  font-size: 18px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 12px 28px;
  line-height: 1.4 !important;
  font-family: "Nunito Sans", sans-serif !important;
}
.subtitle-innner-icontext {
  font-size: 18px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 0px 8px;
  line-height: 1.4 !important;
  font-family: "Nunito Sans", sans-serif !important;
}
.bg-shape {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
}
.bg-shape img {
  width: 100%;
  height: 100%;
  -o-object-position: center bottom;
  object-position: center bottom;
  -o-object-fit: cover;
  object-fit: cover;
}
.grow-logo {
  display: contents;
}
.page-header {
  text-align: center;
  color: #27445b;
}
</style>
